/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

/**
 * Ensures that the given value is of type 'number'.
 * @param value the value to be checked
 * @return the original value if it's of type 'number' else Number.NaN.
 */
export function safeNumber(value) {
  return typeof value === 'number' ? value : Number.NaN;
}
/**
 * Ensures that every element within given array is of type 'number'.
 * @param arr the array to be checked
 * @return the original array if all elements are of type 'number' else a
 * new array with all invalid elements mapped to Number.NaN
 */

export function safeNumberArray(arr) {
  let isSafe = true;

  for (let i = 0; i < arr.length && isSafe; i++) {
    isSafe = typeof arr[i] === 'number';
  }

  if (isSafe) {
    // every element is of type 'number' -> just return the original array
    return arr;
  }

  return arr.map(value => safeNumber(value));
}
/**
 * Ensures that every element within the given array is an array of type 'number'.
 * @param arr2d the array to be checked
 * @return an array of arrays with all elements being of type 'number'; invalid
 * values has been mapped to Number.NaN.
 */

export function safeNumberArrays(arr2d) {
  return arr2d.map(arr => safeNumberArray(arr));
}
